import { Participant } from 'livekit-client';
import { observer } from 'mobx-react-lite';
import { ModerationMenu } from './ModerationMenu';
import { useModerationMenuItems } from './hooks/useModerationMenuItems';
import type { ModerationMenuVariant } from './types';

type Props = {
    participant: Participant;
    variant: ModerationMenuVariant;
};

export const ModerationActionsMenu = observer(({ participant, variant }: Props) => {
    const { isCanShowMenu, menuItems, room } = useModerationMenuItems(participant);

    if (!isCanShowMenu || menuItems.length === 0) {
        return null;
    }

    return <ModerationMenu variant={variant} items={menuItems} participant={participant} room={room} />;
});
